<template>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M10.0254 3.17592C10.2597 3.41022 10.2597 3.79002 10.0254 4.02432L5.22542 8.82432C4.99112 9.05855 4.61132 9.05855 4.37702 8.82432L1.97702 6.42432C1.74964 6.18889 1.75289 5.81467 1.98433 5.58323C2.21577 5.35178 2.58999 5.34853 2.82542 5.57592L4.80122 7.55172L9.17702 3.17592C9.41132 2.94169 9.79112 2.94169 10.0254 3.17592Z"
            fill="#34D399" />
    </svg>

</template>